import { BRAZIL_REGEX } from "./phoneRegex";

export const countryCodes = [
  {
    id: 1,
    country: "Afghanistan",
    code: 93,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(93)?0?(7)([A-Z]?\\d){8}$",
  },
  {
    id: 3,
    country: "Albania",
    code: 355,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(355)?0?(6[78][2-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 4,
    country: "Albania",
    code: 355,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(355)?0?(69)([A-Z]?\\d){7}$",
  },
  {
    id: 5,
    country: "Algeria",
    code: 213,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(213)?0?([56][4-7]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 6,
    country: "Algeria",
    code: 213,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(213)?0?([67]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 7,
    country: "American Samoa",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(684[27][357][0-8]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 8,
    country: "Andorra",
    code: 376,
    length: 9,
    pattern: "#-----",
    regex: "^0?0?(376)?0?([36]){1,1}([A-Z]?\\d){5}$",
  },
  {
    id: 9,
    country: "Andorra",
    code: 376,
    length: 9,
    pattern: "###------",
    regex: "^0?0?(376)?0?(690)([A-Z]?\\d){6}$",
  },
  {
    id: 10,
    country: "Angola",
    code: 244,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(244)?0?(9[1-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 11,
    country: "Anguilla",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(264[57][2-8][1-9]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 12,
    country: "Antigua and Barbuda",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(2687[1-8][0-9]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 13,
    country: "Antigua and Barbuda",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(26872)([A-Z]?\\d){5}$",
  },
  {
    id: 14,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "######------",
    regex: "^0?0?(54)?0?9?(11)?(220215)([A-Z]?\\d){6}$",
  },
  {
    id: 15,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "####-------",
    regex: "^0?0?(54)?0?9?(11)?([2-9]){1}([A-Z]?\\d){7,9}$",
  },
  {
    id: 16,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "######-----",
    regex: "^0?0?(54)?0?(11)?(92[2-9][0-8][1-6]4){1,6}([A-Z]?\\d){5}$",
  },
  {
    id: 17,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "#####------",
    regex: "^0?0?(54)?0?(11)?(9[23][2-9][0-9][0-9]){1,5}([A-Z]?\\d){6}$",
  },
  {
    id: 18,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "####-#-----",
    regex: "^0?0?(54)?0?(11)?(92[2-9][2-9]){1,4}([A-Z]?\\d){1}(4)([A-Z]?\\d){5}$",
  },
  {
    id: 19,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "###-#------",
    regex: "^0?0?(54)?0?(11)?(9[123][3-9]){1,3}([A-Z]?\\d){1}([2-7]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 20,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "###--------",
    regex: "^0?0?(54)?0?(11)?(9[123][4-9]){1,3}([A-Z]?\\d){8}$",
  },
  {
    id: 21,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "###--#-----",
    regex: "^0?0?(54)?0?(11)?(929)([A-Z]?\\d){2}(4)([A-Z]?\\d){5}$",
  },
  {
    id: 22,
    country: "Argentina",
    code: 54,
    length: 14,
    pattern: "##-#-------",
    regex: "^0?0?(54)?0?9?(11)?(92)([A-Z]?\\d){1}(0)([A-Z]?\\d){7}$",
  },
  {
    id: 23,
    country: "Armenia",
    code: 374,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(374)?0?([4-9][1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 24,
    country: "Aruba",
    code: 297,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(297)?0?(622)([A-Z]?\\d){4}$",
  },
  {
    id: 25,
    country: "Aruba",
    code: 297,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(297)?0?([679][4-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 26,
    country: "Aruba",
    code: 297,
    length: 10,
    pattern: "#-#----",
    regex: "^0?0?(297)?0?(6)([A-Z]?\\d){1}(0)([A-Z]?\\d){4}$",
  },
  {
    id: 27,
    country: "Aruba",
    code: 297,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(297)?0?([67]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 28,
    country: "Australia",
    code: 61,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(61)?0?(4[4-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 29,
    country: "Australia",
    code: 61,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(61)?0?(483)([A-Z]?\\d){6}$",
  },
  {
    id: 30,
    country: "Australia",
    code: 61,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(61)?0?(4)([A-Z]?\\d){8}$",
  },
  {
    id: 31,
    country: "Austria",
    code: 43,
    length: 9,
    pattern: "###----",
    regex: "^0?0?(43)?0?(6[567]){1,2}([A-Z]?\\d){4,8}$",
  },
  {
    id: 32,
    country: "Austria",
    code: 43,
    length: 9,
    pattern: "##-----",
    regex: "^0?0?(43)?0?(6[789]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 33,
    country: "Azerbaijan",
    code: 994,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(994)?0?(36554)([A-Z]?\\d){4}$",
  },
  {
    id: 34,
    country: "Azerbaijan",
    code: 994,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(994)?0?([457]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 35,
    country: "Azerbaijan",
    code: 994,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(994)?0?([69][09]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 36,
    country: "Bahamas",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(242[3-8][0-7]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 37,
    country: "Bahamas",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(242[3-7][2-9][1-8]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 38,
    country: "Bahamas",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(2424)([A-Z]?\\d){6}$",
  },
  {
    id: 39,
    country: "Bahamas",
    code: 1,
    length: 11,
    pattern: "####-#----",
    regex: "^0?0?(1)?0?(242[68]){1,4}([A-Z]?\\d){1}([69]){1,1}([A-Z]?\\d){4}$",
  },
  {
    id: 40,
    country: "Bahrain",
    code: 973,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(973)?0?([36][68]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 41,
    country: "Bahrain",
    code: 973,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(973)?0?(3)([A-Z]?\\d){7}$",
  },
  {
    id: 42,
    country: "Bahrain",
    code: 973,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(973)?0?(63[03][03]){1,4}([A-Z]?\\d){4}$",
  },
  {
    id: 43,
    country: "Bahrain",
    code: 973,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(973)?0?(6[36][367]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 44,
    country: "Bangladesh",
    code: 880,
    length: 13,
    pattern: "##--------",
    regex: "^0?0?(880)?0?(1[1-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 45,
    country: "Bangladesh",
    code: 880,
    length: 13,
    pattern: "###",
    regex: "^0?0?(880)?0?$",
  },
  {
    id: 46,
    country: "Bangladesh",
    code: 880,
    length: 13,
    pattern: "####",
    regex: "^0?0?(880)?0?$",
  },
  {
    id: 47,
    country: "Bangladesh",
    code: 880,
    length: 13,
    pattern: "#####",
    regex: "^0?0?(880)?0?$",
  },
  {
    id: 48,
    country: "Bangladesh",
    code: 880,
    length: 13,
    pattern: "###-------",
    regex: "^0?0?(880)?0?(6[46][49]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 49,
    country: "Bangladesh",
    code: 880,
    length: 13,
    pattern: "##",
    regex: "^0?0?(880)?0?$",
  },
  {
    id: 50,
    country: "Barbados",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(246[246][4-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 51,
    country: "Barbados",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(246[28]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 52,
    country: "Barbados",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(246883)([A-Z]?\\d){4}$",
  },
  {
    id: 53,
    country: "Belarus",
    code: 375,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(375)?0?(2[59][1-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 54,
    country: "Belarus",
    code: 375,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(375)?0?([34][34]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 55,
    country: "Belgium",
    code: 32,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(32)?0?(4[5-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 56,
    country: "Belize",
    code: 501,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(501)?0?(6[0-7]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 57,
    country: "Benin",
    code: 229,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(229)?0?(9[0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 58,
    country: "Bermuda",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(441[37]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 59,
    country: "Bermuda",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(4415[0-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 60,
    country: "Bhutan",
    code: 975,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(975)?0?([17][67]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 61,
    country: "Bolivia",
    code: 591,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(591)?0?([67]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 62,
    country: "Bonaire Sint Eustatius and Saba",
    code: 599,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(599)?0?([34]1[689]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 63,
    country: "Bonaire Sint Eustatius and Saba",
    code: 599,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(599)?0?(7[0-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 64,
    country: "Bosnia and Herzegovina",
    code: 387,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(387)?0?(6040[0-4]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 65,
    country: "Bosnia and Herzegovina",
    code: 387,
    length: 12,
    pattern: "##------",
    regex: "^0?0?(387)?0?(6[1-6]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 66,
    country: "Bosnia and Herzegovina",
    code: 387,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(387)?0?(644)([A-Z]?\\d){6}$",
  },
  {
    id: 67,
    country: "Bosnia and Herzegovina",
    code: 387,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(387)?0?(67)([A-Z]?\\d){7}$",
  },
  {
    id: 68,
    country: "Botswana",
    code: 267,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(267)?0?(7[1-6]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 69,
    country: "Botswana",
    code: 267,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(267)?0?(77[0-8]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 70,
    country: "Botswana",
    code: 267,
    length: 11,
    pattern: "#####---",
    regex: "^0?0?(267)?0?(77200)([A-Z]?\\d){3}$",
  },
  {
    id: 74,
    country: "Brazil",
    code: 55,
    length: 12,
    pattern: "--#--------",
    regex: BRAZIL_REGEX,
  },
  {
    id: 75,
    country: "British Indian Ocean Territory",
    code: 246,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(246)?0?(38)([A-Z]?\\d){5}$",
  },
  {
    id: 76,
    country: "Brunei Darussalam",
    code: 673,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(673)?0?(22[89]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 77,
    country: "Brunei Darussalam",
    code: 673,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(673)?0?([78]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 78,
    country: "Bulgaria",
    code: 359,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(359)?0?(43[0-9]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 79,
    country: "Bulgaria",
    code: 359,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(359)?0?(8[789]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 80,
    country: "Bulgaria",
    code: 359,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(359)?0?(99[69]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 81,
    country: "Burkina Faso",
    code: 226,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(226)?0?([05][1-8]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 82,
    country: "Burkina Faso",
    code: 226,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(226)?0?([67]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 83,
    country: "Burundi",
    code: 257,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(257)?0?([67][1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 84,
    country: "Cambodia",
    code: 855,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(855)?0?([1-9]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 85,
    country: "Cambodia",
    code: 855,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(855)?0?([1-9]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 86,
    country: "Cambodia",
    code: 855,
    length: 11,
    pattern: "#-##-----",
    regex: "^0?0?(855)?0?([234]){1,1}([A-Z]?\\d){1}(48)([A-Z]?\\d){5}$",
  },
  {
    id: 87,
    country: "Cambodia",
    code: 855,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(855)?0?(88)([A-Z]?\\d){7}$",
  },
  {
    id: 88,
    country: "Cambodia",
    code: 855,
    length: 11,
    pattern: "--##-----",
    regex: "^0?0?(855)?0?([A-Z]?\\d){2}(48)([A-Z]?\\d){5}$",
  },
  {
    id: 89,
    country: "Cameroon",
    code: 237,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(237)?0?(6[5-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 90,
    country: "Canada",
    code: 1,
    length: 11,
    pattern: "###-------",
    regex: "^0?0?(1)?0?([2-8][0-7][0-9]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 91,
    country: "Canada",
    code: 1,
    length: 11,
    pattern: "#-#-------",
    regex: "^0?0?(1)?0?([28]){1,1}([A-Z]?\\d){1}([679]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 92,
    country: "Canada",
    code: 1,
    length: 11,
    pattern: "##--------",
    regex: "^0?0?(1)?0?([4-9][0-8]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 93,
    country: "Cape Verde",
    code: 238,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(238)?0?([345][1-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 94,
    country: "Cape Verde",
    code: 238,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(238)?0?(9)([A-Z]?\\d){6}$",
  },
  {
    id: 95,
    country: "Cayman Islands",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(345[59][1-4]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 96,
    country: "Cayman Islands",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(345[56][457][069]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 97,
    country: "Central African Republic",
    code: 236,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(236)?0?(7[0-7]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 98,
    country: "Chad",
    code: 235,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(235)?0?([67][0-8]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 99,
    country: "Chad",
    code: 235,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(235)?0?(9)([A-Z]?\\d){7}$",
  },
  {
    id: 100,
    country: "Chile",
    code: 56,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(56)?0?([28][02]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 101,
    country: "Chile",
    code: 56,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(56)?0?(232)([A-Z]?\\d){6}$",
  },
  {
    id: 102,
    country: "Chile",
    code: 56,
    length: 11,
    pattern: "#####----",
    regex: "^0?0?(56)?0?(23300)([A-Z]?\\d){4}$",
  },
  {
    id: 103,
    country: "Chile",
    code: 56,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(56)?0?([3-9]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 104,
    country: "Chile",
    code: 56,
    length: 11,
    pattern: "---------",
    regex: "^0?0?(56)?0?([A-Z]?\\d){9}$",
  },
  {
    id: 105,
    country: "China",
    code: 86,
    length: 13,
    pattern: "##---------",
    regex: "^0?0?(86)?0?(1[4-9]){1,2}([A-Z]?\\d){9}$",
  },
  {
    id: 106,
    country: "China",
    code: 86,
    length: 13,
    pattern: "####-------",
    regex: "^0?0?(86)?0?(1740)([A-Z]?\\d){7}$",
  },
  {
    id: 107,
    country: "China",
    code: 86,
    length: 13,
    pattern: "#----------",
    regex: "^0?0?(86)?0?(1)([A-Z]?\\d){10}$",
  },
  {
    id: 108,
    country: "Christmas Island",
    code: 61,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(61)?0?(4[4-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 109,
    country: "Christmas Island",
    code: 61,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(61)?0?(483)([A-Z]?\\d){6}$",
  },
  {
    id: 110,
    country: "Christmas Island",
    code: 61,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(61)?0?(4)([A-Z]?\\d){8}$",
  },
  {
    id: 111,
    country: "Cocos (Keeling) Islands",
    code: 61,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(61)?0?(4[4-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 112,
    country: "Cocos (Keeling) Islands",
    code: 61,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(61)?0?(483)([A-Z]?\\d){6}$",
  },
  {
    id: 113,
    country: "Cocos (Keeling) Islands",
    code: 61,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(61)?0?(4)([A-Z]?\\d){8}$",
  },
  {
    id: 114,
    country: "Colombia",
    code: 57,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(57)?0?(3[0-5]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 115,
    country: "Colombia",
    code: 57,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(57)?0?(33[03][03]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 116,
    country: "Colombia",
    code: 57,
    length: 12,
    pattern: "######----",
    regex: "^0?0?(57)?0?(33330[01]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 117,
    country: "Colombia",
    code: 57,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(57)?0?(3[37][03]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 118,
    country: "Comoros",
    code: 269,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(269)?0?([34]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 119,
    country: "Congo",
    code: 242,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(242)?0?(0[1-6]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 120,
    country: "Cook Islands",
    code: 682,
    length: 8,
    pattern: "#----",
    regex: "^0?0?(682)?0?([578]){1,1}([A-Z]?\\d){4}$",
  },
  {
    id: 121,
    country: "Costa Rica",
    code: 506,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(506)?0?(5[07]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 122,
    country: "Costa Rica",
    code: 506,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(506)?0?(6500)([A-Z]?\\d){4}$",
  },
  {
    id: 123,
    country: "Costa Rica",
    code: 506,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(506)?0?([678]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 124,
    country: "Cote dIvoire",
    code: 225,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(225)?0?([068]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 125,
    country: "Cote dIvoire",
    code: 225,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(225)?0?(9[57]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 126,
    country: "Cote dIvoire",
    code: 225,
    length: 11,
    pattern: "--------",
    regex: "^0?0?(225)?0?([A-Z]?\\d){8}$",
  },
  {
    id: 127,
    country: "Croatia",
    code: 385,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(385)?0?(9[07]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 128,
    country: "Croatia",
    code: 385,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(385)?0?(9751)([A-Z]?\\d){5}$",
  },
  {
    id: 129,
    country: "Croatia",
    code: 385,
    length: 12,
    pattern: "##------",
    regex: "^0?0?(385)?0?(98)([A-Z]?\\d){6}$",
  },
  {
    id: 130,
    country: "Croatia",
    code: 385,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(385)?0?(9)([A-Z]?\\d){8}$",
  },
  {
    id: 131,
    country: "Cuba",
    code: 53,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(53)?0?(5)([A-Z]?\\d){7}$",
  },
  {
    id: 132,
    country: "Curacao",
    code: 599,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(599)?0?(9[56][1-9]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 133,
    country: "Curacao",
    code: 599,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(599)?0?(953[01]){1,4}([A-Z]?\\d){4}$",
  },
  {
    id: 134,
    country: "Cyprus",
    code: 357,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(357)?0?(9[4-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 135,
    country: "Czech Republic",
    code: 420,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(420)?0?([67]0[1-8]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 136,
    country: "Czech Republic",
    code: 420,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(420)?0?(7[2-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 137,
    country: "Denmark",
    code: 45,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(45)?0?([2-7]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 138,
    country: "Denmark",
    code: 45,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(45)?0?([89][1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 139,
    country: "Djibouti",
    code: 253,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(253)?0?(77)([A-Z]?\\d){6}$",
  },
  {
    id: 140,
    country: "Dominica",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(767[236][1-9][1-7]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 141,
    country: "Dominican Republic",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(8[01234]9)([A-Z]?\\d){6,7}$",
  },
  {
    id: 142,
    country: "Ecuador",
    code: 593,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(593)?0?(9[36][49]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 143,
    country: "Ecuador",
    code: 593,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(593)?0?(96)([A-Z]?\\d){7}$",
  },
  {
    id: 144,
    country: "Ecuador",
    code: 593,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(593)?0?(9)([A-Z]?\\d){8}$",
  },
  {
    id: 145,
    country: "Egypt",
    code: 20,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(20)?0?(1[0-5]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 146,
    country: "El Salvador",
    code: 503,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(503)?0?([67]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 147,
    country: "Equatorial Guinea",
    code: 240,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(240)?0?(55[015]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 148,
    country: "Eritrea",
    code: 291,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(291)?0?(17[123]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 149,
    country: "Eritrea",
    code: 291,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(291)?0?(7)([A-Z]?\\d){6}$",
  },
  {
    id: 150,
    country: "Estonia",
    code: 372,
    length: 10,
    pattern: "####---",
    regex: "^0?0?(372)?0?(5195)([A-Z]?\\d){3}$",
  },
  {
    id: 151,
    country: "Estonia",
    code: 372,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(372)?0?(5[15]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 152,
    country: "Estonia",
    code: 372,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(372)?0?(56[45]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 153,
    country: "Estonia",
    code: 372,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(372)?0?(5)([A-Z]?\\d){6}$",
  },
  {
    id: 154,
    country: "Estonia",
    code: 372,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(372)?0?([58]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 155,
    country: "Ethiopia",
    code: 251,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(251)?0?(9)([A-Z]?\\d){8}$",
  },
  {
    id: 156,
    country: "Falkland Islands",
    code: 500,
    length: 8,
    pattern: "#----",
    regex: "^0?0?(500)?0?([56]){1,1}([A-Z]?\\d){4}$",
  },
  {
    id: 157,
    country: "Faroe Islands",
    code: 298,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(298)?0?([27][1-9]){1,2}([A-Z]?\\d){4}$",
  },
  {
    id: 158,
    country: "Faroe Islands",
    code: 298,
    length: 9,
    pattern: "#-----",
    regex: "^0?0?(298)?0?(5)([A-Z]?\\d){5}$",
  },
  {
    id: 159,
    country: "Fiji",
    code: 679,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(679)?0?([279]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 160,
    country: "Fiji",
    code: 679,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(679)?0?([458][0-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 161,
    country: "Finland",
    code: 358,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(358)?0?([45][0-8]){1,2}([A-Z]?\\d){4,7}$",
  },
  {
    id: 162,
    country: "France",
    code: 33,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(33)?0?(700)([A-Z]?\\d){6}$",
  },
  {
    id: 163,
    country: "France",
    code: 33,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(33)?0?([67][3-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 164,
    country: "French Guiana",
    code: 594,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(594)?0?(694[0-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 165,
    country: "French Guiana",
    code: 594,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(594)?0?(6943[0-8]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 166,
    country: "French Polynesia",
    code: 689,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(689)?0?(8[789]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 167,
    country: "Gabon",
    code: 241,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(241)?0?([067][2-7]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 168,
    country: "Gabon",
    code: 241,
    length: 11,
    pattern: "#------",
    regex: "^0?0?(241)?0?([2-7]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 169,
    country: "Gambia",
    code: 220,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(220)?0?([2-9]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 170,
    country: "Gambia",
    code: 220,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(220)?0?(5[0-3]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 171,
    country: "Georgia",
    code: 995,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(995)?0?(5[0-8][0-8][0-8][0-8]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 172,
    country: "Georgia",
    code: 995,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(995)?0?(5[579]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 173,
    country: "Georgia",
    code: 995,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(995)?0?([57][69][08]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 174,
    country: "Georgia",
    code: 995,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(995)?0?(5858)([A-Z]?\\d){5}$",
  },
  {
    id: 175,
    country: "Georgia",
    code: 995,
    length: 12,
    pattern: "#-#------",
    regex: "^0?0?(995)?0?(5)([A-Z]?\\d){1}(4)([A-Z]?\\d){6}$",
  },
  {
    id: 176,
    country: "Germany",
    code: 49,
    length: 13,
    pattern: "###--------",
    regex: "^0?0?(49)?0?(15[0-9]){1,3}([A-Z]?\\d){8}$",
  },
  {
    id: 177,
    country: "Germany",
    code: 49,
    length: 13,
    pattern: "###-------",
    regex: "^0?0?(49)?0?(16[023]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 178,
    country: "Germany",
    code: 49,
    length: 13,
    pattern: "##--------",
    regex: "^0?0?(49)?0?(17)([A-Z]?\\d){8}$",
  },
  {
    id: 179,
    country: "Ghana",
    code: 233,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(233)?0?([25][0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 180,
    country: "Ghana",
    code: 233,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(233)?0?(5[69][0-6]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 181,
    country: "Gibraltar",
    code: 350,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(350)?0?(5[1-8]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 182,
    country: "Gibraltar",
    code: 350,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(350)?0?(6[02][69]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 183,
    country: "Greece",
    code: 30,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(30)?0?(68[5-9]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 184,
    country: "Greece",
    code: 30,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(30)?0?([69][49]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 185,
    country: "Greenland",
    code: 299,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(299)?0?([245][1-9]){1,2}([A-Z]?\\d){4}$",
  },
  {
    id: 186,
    country: "Grenada",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(473[45][0-3]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 187,
    country: "Grenada",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(473[49][05][18]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 188,
    country: "Guadeloupe",
    code: 590,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(590)?0?(691[23][0-9]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 189,
    country: "Guam",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(671[3-6][0-8][0-8]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 190,
    country: "Guam",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(671[3-9][2-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 191,
    country: "Guam",
    code: 1,
    length: 11,
    pattern: "####-#----",
    regex: "^0?0?(1)?0?(671[78]){1,4}([A-Z]?\\d){1}([78]){1,1}([A-Z]?\\d){4}$",
  },
  {
    id: 192,
    country: "Guatemala",
    code: 502,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(502)?0?([345]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 193,
    country: "Guernsey",
    code: 44,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(44)?0?(7[78][38][19]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 194,
    country: "Guernsey",
    code: 44,
    length: 12,
    pattern: "#####-----",
    regex: "^0?0?(44)?0?(7911[17]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 195,
    country: "Guinea-Bissau",
    code: 245,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(245)?0?(9[67][5-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 196,
    country: "Guinea",
    code: 224,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(224)?0?(6[0-6]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 197,
    country: "Guyana",
    code: 592,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(592)?0?(6)([A-Z]?\\d){6}$",
  },
  {
    id: 198,
    country: "Haiti",
    code: 509,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(509)?0?([34]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 199,
    country: "Honduras",
    code: 504,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(504)?0?([3-9]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 200,
    country: "Hong Kong",
    code: 852,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(852)?0?([4-9][0-6][0-9]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 201,
    country: "Hong Kong",
    code: 852,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(852)?0?([569][0-7]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 202,
    country: "Hong Kong",
    code: 852,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(852)?0?(5730)([A-Z]?\\d){4}$",
  },
  {
    id: 203,
    country: "Hong Kong",
    code: 852,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(852)?0?([569]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 204,
    country: "Hungary",
    code: 36,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(36)?0?([2-7][01]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 205,
    country: "Iceland",
    code: 354,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(354)?0?([678][1-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 206,
    country: "Iceland",
    code: 354,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(354)?0?(670)([A-Z]?\\d){4}$",
  },
  {
    id: 207,
    country: "Iceland",
    code: 354,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(354)?0?([78]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 208,
    country: "India",
    code: 91,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(91)?0?([678][0-9][0-9]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 209,
    country: "India",
    code: 91,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(91)?0?([678][0-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 210,
    country: "India",
    code: 91,
    length: 12,
    pattern: "#-#-------",
    regex: "^0?0?(91)?0?(6)([A-Z]?\\d){1}(1)([A-Z]?\\d){7}$",
  },
  {
    id: 211,
    country: "India",
    code: 91,
    length: 12,
    pattern: "#---------",
    regex: "^0?0?(91)?0?([689]){1,1}([A-Z]?\\d){9}$",
  },
  {
    id: 212,
    country: "India",
    code: 91,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(91)?0?([78][3-9][1-8][179]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 213,
    country: "India",
    code: 91,
    length: 12,
    pattern: "##-#------",
    regex: "^0?0?(91)?0?(74)([A-Z]?\\d){1}(7)([A-Z]?\\d){6}$",
  },
  {
    id: 214,
    country: "India",
    code: 91,
    length: 12,
    pattern: "#####-----",
    regex: "^0?0?(91)?0?(79313)([A-Z]?\\d){5}$",
  },
  {
    id: 215,
    country: "India",
    code: 91,
    length: 12,
    pattern: "####---#------",
    regex: "^0?0?(91)?0?(8167)([A-Z]?\\d){3}(7)([A-Z]?\\d){6}$",
  },
  {
    id: 216,
    country: "India",
    code: 91,
    length: 12,
    pattern: "###----#------",
    regex: "^0?0?(91)?0?(816)([A-Z]?\\d){4}(7)([A-Z]?\\d){6}$",
  },
  {
    id: 217,
    country: "India",
    code: 91,
    length: 12,
    pattern: "##-#---#------",
    regex: "^0?0?(91)?0?(8[2-7]){1,2}([A-Z]?\\d){1}(7)([A-Z]?\\d){3}(7)([A-Z]?\\d){6}$",
  },
  {
    id: 218,
    country: "India",
    code: 91,
    length: 12,
    pattern: "##-----#------",
    regex: "^0?0?(91)?0?(8[2-7]){1,2}([A-Z]?\\d){5}(7)([A-Z]?\\d){6}$",
  },
  {
    id: 219,
    country: "India",
    code: 91,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(91)?0?(837)([A-Z]?\\d){6}$",
  },
  {
    id: 220,
    country: "India",
    code: 91,
    length: 12,
    pattern: "###--#------",
    regex: "^0?0?(91)?0?(883)([A-Z]?\\d){2}(7)([A-Z]?\\d){6}$",
  },
  {
    id: 221,
    country: "Indonesia",
    code: 62,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(62)?0?(8[1-9]){1,2}([A-Z]?\\d){7,10}$",
  },
  {
    id: 222,
    country: "Iran",
    code: 98,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(98)?0?(9[09][489][0-9]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 223,
    country: "Iran",
    code: 98,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(98)?0?(9[029]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 224,
    country: "Iran",
    code: 98,
    length: 12,
    pattern: "###-#-----",
    regex: "^0?0?(98)?0?(995)([A-Z]?\\d){1}(0)([A-Z]?\\d){5}$",
  },
  {
    id: 225,
    country: "Iran",
    code: 98,
    length: 12,
    pattern: "#####-----",
    regex: "^0?0?(98)?0?(99[89][278][178]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 226,
    country: "Iran",
    code: 98,
    length: 12,
    pattern: "#---------",
    regex: "^0?0?(98)?0?(9)([A-Z]?\\d){9}$",
  },
  {
    id: 227,
    country: "Iraq",
    code: 964,
    length: 13,
    pattern: "##--------",
    regex: "^0?0?(964)?0?(7[3-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 228,
    country: "Ireland",
    code: 353,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(353)?0?(8[3-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 229,
    country: "Isle of Man",
    code: 44,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(44)?0?(7[59]24){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 230,
    country: "Isle of Man",
    code: 44,
    length: 12,
    pattern: "#####-----",
    regex: "^0?0?(44)?0?(7624[0-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 231,
    country: "Isle of Man",
    code: 44,
    length: 12,
    pattern: "######----",
    regex: "^0?0?(44)?0?(76245[06]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 232,
    country: "Israel",
    code: 972,
    length: 12,
    pattern: "##-------",
    regex: "^(05|\\+?0?0?(9725)?)(([A-Z]?\\d){6,8})$",
  },
  {
    id: 233,
    country: "Israel",
    code: 972,
    length: 12,
    pattern: "####-----",
    regex: "^(05501|\\+?0?0?9725501)([A-Z]?\\d){5}$",
  },
  {
    id: 234,
    country: "Israel",
    code: 972,
    length: 12,
    pattern: "###------",
    regex: "^(055[2-9]|(\\+?0?0?(97255[2-9])){1,6})([A-Z]?\\d){6}$",
  },
  {
    id: 235,
    country: "Israel",
    code: 972,
    length: 12,
    pattern: "#--------",
    regex: "^(05|\\+?0?0?9725)([A-Z]?\\d){8}$|^(05)([A-Z]?\\d){8}$",
  },
  {
    id: 236,
    country: "Italy",
    code: 39,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(39)?0?(3[1-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 237,
    country: "Italy",
    code: 39,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(39)?0?(3[2-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 238,
    country: "Jamaica",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(876[25]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 239,
    country: "Jamaica",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(876[579][0-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 240,
    country: "Jamaica",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(876517)([A-Z]?\\d){4}$",
  },
  {
    id: 241,
    country: "Jamaica",
    code: 1,
    length: 11,
    pattern: "####-#----",
    regex: "^0?0?(1)?0?(8769)([A-Z]?\\d){1}(9)([A-Z]?\\d){4}$",
  },
  {
    id: 242,
    country: "Jamaica",
    code: 1,
    length: 11,
    pattern: "###-------",
    regex: "^0?0?(1)?0?(876)([A-Z]?\\d){7}$",
  },
  {
    id: 243,
    country: "Japan",
    code: 81,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(81)?0?(001)([A-Z]?\\d){7}$",
  },
  {
    id: 244,
    country: "Jersey",
    code: 44,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(44)?0?(7[589][023][79]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 245,
    country: "Jersey",
    code: 44,
    length: 12,
    pattern: "#####-----",
    regex: "^0?0?(44)?0?(77[09][07][3-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 246,
    country: "Jordan",
    code: 962,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(962)?0?(755[0-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 247,
    country: "Jordan",
    code: 962,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(962)?0?(7[78][0-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 248,
    country: "Jordan",
    code: 962,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(962)?0?(79)([A-Z]?\\d){7}$",
  },
  {
    id: 249,
    country: "Kazakhstan",
    code: 7,
    length: 11,
    pattern: "###-------",
    regex: "^0?0?(7)?0?(7[0-8][0-8]){1,3}([A-Z]?\\d){6,8}$",
  },
  {
    id: 250,
    country: "Kenya",
    code: 254,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(254)?0?(1[01][012]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 251,
    country: "Kenya",
    code: 254,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(254)?0?(7)([A-Z]?\\d){8}$",
  },
  {
    id: 252,
    country: "Kiribati",
    code: 686,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(686)?0?([67]30){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 253,
    country: "Kiribati",
    code: 686,
    length: 11,
    pattern: "#####---",
    regex: "^0?0?(686)?0?(73140)([A-Z]?\\d){3}$",
  },
  {
    id: 254,
    country: "Kiribati",
    code: 686,
    length: 11,
    pattern: "-###----",
    regex: "^0?0?(686)?0?([A-Z]?\\d){1}(200)([A-Z]?\\d){4}$",
  },
  {
    id: 255,
    country: "Korea Democratic Peoples Republic",
    code: 850,
    length: 13,
    pattern: "###-------",
    regex: "^0?0?(850)?0?(19[123]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 256,
    country: "Korea Republic",
    code: 82,
    length: 11,
    pattern: "####-----",
    regex: "^0?0?(82)?0?(1059)([A-Z]?\\d){5}$",
  },
  {
    id: 257,
    country: "Korea Republic",
    code: 82,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(82)?0?(1[02][25]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 258,
    country: "Korea Republic",
    code: 82,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(82)?0?(1[02]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 259,
    country: "Korea Republic",
    code: 82,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(82)?0?(1)([A-Z]?\\d){9}$",
  },
  {
    id: 260,
    country: "Kuwait",
    code: 965,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(965)?0?([569][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 261,
    country: "Kuwait",
    code: 965,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(965)?0?([569][2-8][0-8][0-8]){1,4}([A-Z]?\\d){4}$",
  },
  {
    id: 262,
    country: "Kuwait",
    code: 965,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(965)?0?([569][1-9][0-8]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 263,
    country: "Kuwait",
    code: 965,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(965)?0?([59]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 264,
    country: "Kyrgyzstan",
    code: 996,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(996)?0?([29][029]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 265,
    country: "Kyrgyzstan",
    code: 996,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(996)?0?(31258)([A-Z]?\\d){4}$",
  },
  {
    id: 266,
    country: "Kyrgyzstan",
    code: 996,
    length: 12,
    pattern: "######---",
    regex: "^0?0?(996)?0?(312973)([A-Z]?\\d){3}$",
  },
  {
    id: 267,
    country: "Kyrgyzstan",
    code: 996,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(996)?0?([57]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 268,
    country: "Kyrgyzstan",
    code: 996,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(996)?0?(755)([A-Z]?\\d){6}$",
  },
  {
    id: 269,
    country: "Kyrgyzstan",
    code: 996,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(996)?0?(8801)([A-Z]?\\d){5}$",
  },
  {
    id: 270,
    country: "Lao Peoples Democratic Republic",
    code: 856,
    length: 13,
    pattern: "###-------",
    regex: "^0?0?(856)?0?(20[29]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 271,
    country: "Lao Peoples Democratic Republic",
    code: 856,
    length: 13,
    pattern: "####------",
    regex: "^0?0?(856)?0?(20[57][2-9]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 272,
    country: "Latvia",
    code: 371,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(371)?0?(2)([A-Z]?\\d){7}$",
  },
  {
    id: 273,
    country: "Lebanon",
    code: 961,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(961)?0?(3)([A-Z]?\\d){6}$",
  },
  {
    id: 274,
    country: "Lebanon",
    code: 961,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(961)?0?([78][1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 275,
    country: "Lebanon",
    code: 961,
    length: 10,
    pattern: "####----",
    regex: "^0?0?(961)?0?(7932)([A-Z]?\\d){4}$",
  },
  {
    id: 276,
    country: "Lebanon",
    code: 961,
    length: 10,
    pattern: "###-----",
    regex: "^0?0?(961)?0?(793)([A-Z]?\\d){5}$",
  },
  {
    id: 277,
    country: "Lebanon",
    code: 961,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(961)?0?(7)([A-Z]?\\d){7}$",
  },
  {
    id: 278,
    country: "Lesotho",
    code: 266,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(266)?0?([56]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 279,
    country: "Liberia",
    code: 231,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(231)?0?(4[67]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 280,
    country: "Liberia",
    code: 231,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(231)?0?(5)([A-Z]?\\d){6}$",
  },
  {
    id: 281,
    country: "Liberia",
    code: 231,
    length: 10,
    pattern: "##-------",
    regex: "^0?0?(231)?0?([78][78]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 282,
    country: "Libya",
    code: 218,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(218)?0?(9[1-6]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 283,
    country: "Liechtenstein",
    code: 423,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(423)?0?(6[46][138][09]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 284,
    country: "Liechtenstein",
    code: 423,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(423)?0?(6[46][029]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 285,
    country: "Liechtenstein",
    code: 423,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(423)?0?(65)([A-Z]?\\d){7}$",
  },
  {
    id: 286,
    country: "Liechtenstein",
    code: 423,
    length: 12,
    pattern: "###----",
    regex: "^0?0?(423)?0?(7[45][26]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 287,
    country: "Liechtenstein",
    code: 423,
    length: 12,
    pattern: "#------",
    regex: "^0?0?(423)?0?(7)([A-Z]?\\d){6}$",
  },
  {
    id: 288,
    country: "Lithuania",
    code: 370,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(370)?0?(6)([A-Z]?\\d){7}$",
  },
  {
    id: 289,
    country: "Luxembourg",
    code: 352,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(352)?0?(6[2-9][1-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 290,
    country: "Macao",
    code: 853,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(853)?0?(68)([A-Z]?\\d){6}$",
  },
  {
    id: 291,
    country: "Macedonia",
    code: 389,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(389)?0?(7[0-8]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 292,
    country: "Macedonia",
    code: 389,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(389)?0?(7[39][234]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 293,
    country: "Macedonia",
    code: 389,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(389)?0?(74[26][01]){1,4}([A-Z]?\\d){4}$",
  },
  {
    id: 294,
    country: "Madagascar",
    code: 261,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(261)?0?(3[2-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 295,
    country: "Malawi",
    code: 265,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(265)?0?(111)([A-Z]?\\d){6}$",
  },
  {
    id: 296,
    country: "Malawi",
    code: 265,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(265)?0?([789][789]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 297,
    country: "Malaysia",
    code: 60,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(60)?0?(1[0-8][1-9]){1,3}([A-Z]?\\d){6,7}$",
  },
  {
    id: 298,
    country: "Malaysia",
    code: 60,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(60)?0?(1[0689]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 299,
    country: "Malaysia",
    code: 60,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(60)?0?(11[67][01]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 300,
    country: "Malaysia",
    code: 60,
    length: 11,
    pattern: "###-------",
    regex: "^0?0?(60)?0?(1[15][69]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 301,
    country: "Malaysia",
    code: 60,
    length: 11,
    pattern: "####-----",
    regex: "^0?0?(60)?0?(1847)([A-Z]?\\d){5}$",
  },
  {
    id: 302,
    country: "Maldives",
    code: 960,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(960)?0?(46[46]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 303,
    country: "Maldives",
    code: 960,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(960)?0?([79][1-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 304,
    country: "Mali",
    code: 223,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(223)?0?(2079)([A-Z]?\\d){4}$",
  },
  {
    id: 305,
    country: "Mali",
    code: 223,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(223)?0?(217)([A-Z]?\\d){5}$",
  },
  {
    id: 306,
    country: "Mali",
    code: 223,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(223)?0?([679]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 307,
    country: "Mali",
    code: 223,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(223)?0?(8[239]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 308,
    country: "Malta",
    code: 356,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(356)?0?([79][28][1-9][0-9]){1,4}([A-Z]?\\d){4}$",
  },
  {
    id: 309,
    country: "Malta",
    code: 356,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(356)?0?(7)([A-Z]?\\d){7}$",
  },
  {
    id: 310,
    country: "Malta",
    code: 356,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(356)?0?(9[268][19]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 311,
    country: "Malta",
    code: 356,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(356)?0?(99)([A-Z]?\\d){6}$",
  },
  {
    id: 312,
    country: "Marshall Islands",
    code: 692,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(692)?0?([2-5][2-5][569]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 313,
    country: "Martinique",
    code: 596,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(596)?0?(696[0-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 314,
    country: "Martinique",
    code: 596,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(596)?0?(69[67][256][0-7]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 315,
    country: "Mauritania",
    code: 222,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(222)?0?([234][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 316,
    country: "Mauritius",
    code: 230,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(230)?0?(5[2-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 317,
    country: "Mauritius",
    code: 230,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(230)?0?(5[48][27]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 318,
    country: "Mayotte",
    code: 262,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(262)?0?(639[0-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 319,
    country: "Mayotte",
    code: 262,
    length: 12,
    pattern: "###-#----",
    regex: "^0?0?(262)?0?(639)([A-Z]?\\d){1}(0)([A-Z]?\\d){4}$",
  },
  {
    id: 320,
    country: "Mayotte",
    code: 262,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(262)?0?(639)([A-Z]?\\d){6}$",
  },
  {
    id: 321,
    country: "Mexico",
    code: 52,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(52)?0?([2-9][1-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 322,
    country: "Mexico",
    code: 52,
    length: 12,
    pattern: "###--------",
    regex: "^0?0?(52)?0?(1[2-9][1-9]){1,3}([A-Z]?\\d){8}$",
  },
  {
    id: 323,
    country: "Mexico",
    code: 52,
    length: 12,
    pattern: "##---------",
    regex: "^0?0?(52)?0?(1[3-9]){1,2}([A-Z]?\\d){9}$",
  },
  {
    id: 324,
    country: "Mexico",
    code: 52,
    length: 12,
    pattern: "####-------",
    regex: "^0?0?(52)?0?(1588)([A-Z]?\\d){7}$",
  },
  {
    id: 325,
    country: "Mexico",
    code: 52,
    length: 12,
    pattern: "#---------",
    regex: "^0?0?(52)?0?([3-9]){1,1}([A-Z]?\\d){9}$",
  },
  {
    id: 326,
    country: "Mexico",
    code: 52,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(52)?0?(588)([A-Z]?\\d){7}$",
  },
  {
    id: 327,
    country: "Micronesia",
    code: 691,
    length: 10,
    pattern: "####---",
    regex: "^0?0?(691)?0?(300[1-9]){1,4}([A-Z]?\\d){3}$",
  },
  {
    id: 328,
    country: "Micronesia",
    code: 691,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(691)?0?(9[2-7]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 329,
    country: "Moldova",
    code: 373,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(373)?0?(562)([A-Z]?\\d){5}$",
  },
  {
    id: 330,
    country: "Moldova",
    code: 373,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(373)?0?([67][1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 331,
    country: "Monaco",
    code: 377,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(377)?0?(3)([A-Z]?\\d){7}$",
  },
  {
    id: 332,
    country: "Monaco",
    code: 377,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(377)?0?(45[1-9]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 333,
    country: "Monaco",
    code: 377,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(377)?0?(6)([A-Z]?\\d){8}$",
  },
  {
    id: 334,
    country: "Mongolia",
    code: 976,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(976)?0?([89][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 335,
    country: "Mongolia",
    code: 976,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(976)?0?([89][23][0-4]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 336,
    country: "Montenegro",
    code: 382,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(382)?0?(6[36][0-5]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 337,
    country: "Montenegro",
    code: 382,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(382)?0?(6[789]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 338,
    country: "Montserrat",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(66449[2-6]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 339,
    country: "Mozambique",
    code: 258,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(258)?0?(8[2-7]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 340,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(95)?0?(9[259]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 341,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "##--------",
    regex: "^0?0?(95)?0?(9[2-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 342,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "###-------",
    regex: "^0?0?(95)?0?(9[368][4-9]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 343,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "##-------",
    regex: "^0?0?(95)?0?(9[34]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 344,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "####-----",
    regex: "^0?0?(95)?0?(9488)([A-Z]?\\d){5}$",
  },
  {
    id: 345,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "###------",
    regex: "^0?0?(95)?0?(973)([A-Z]?\\d){6}$",
  },
  {
    id: 346,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "#-#------",
    regex: "^0?0?(95)?0?(9)([A-Z]?\\d){1}(1)([A-Z]?\\d){6}$",
  },
  {
    id: 347,
    country: "Myanmar",
    code: 95,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(95)?0?(9)([A-Z]?\\d){7}$",
  },
  {
    id: 348,
    country: "Namibia",
    code: 264,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(264)?0?(8[1-5]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 349,
    country: "Nauru",
    code: 674,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(674)?0?(55[4-9]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 350,
    country: "Nepal",
    code: 977,
    length: 13,
    pattern: "###-------",
    regex: "^0?0?(977)?0?(9[678][0-8]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 351,
    country: "Netherlands",
    code: 31,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(31)?0?(6[1-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 352,
    country: "New Caledonia",
    code: 687,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(687)?0?([58][0-9]){1,2}([A-Z]?\\d){4}$",
  },
  {
    id: 353,
    country: "New Caledonia",
    code: 687,
    length: 9,
    pattern: "#-----",
    regex: "^0?0?(687)?0?([79]){1,1}([A-Z]?\\d){5}$",
  },
  {
    id: 354,
    country: "New Zealand",
    code: 64,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(64)?0?(2[0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 355,
    country: "New Zealand",
    code: 64,
    length: 11,
    pattern: "##--------",
    regex: "^0?0?(64)?0?(2[0-8]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 356,
    country: "New Zealand",
    code: 64,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(64)?0?(21)([A-Z]?\\d){6}$",
  },
  {
    id: 357,
    country: "Nicaragua",
    code: 505,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(505)?0?([56][3-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 358,
    country: "Nicaragua",
    code: 505,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(505)?0?([578]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 359,
    country: "Nicaragua",
    code: 505,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(505)?0?(6[27][07]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 360,
    country: "Niger",
    code: 227,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(227)?0?(8[0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 361,
    country: "Niger",
    code: 227,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(227)?0?(9)([A-Z]?\\d){7}$",
  },
  {
    id: 362,
    country: "Nigeria",
    code: 234,
    length: 13,
    pattern: "###-------",
    regex: "^0?0?(234)?0?(8[01][19]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 363,
    country: "Nigeria",
    code: 234,
    length: 13,
    pattern: "##--------",
    regex: "^0?0?(234)?0?([89][01]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 364,
    country: "Niue",
    code: 683,
    length: 10,
    pattern: "####---",
    regex: "^0?0?(683)?0?(888[4-9]){1,4}([A-Z]?\\d){3}$",
  },
  {
    id: 365,
    country: "Norfolk Island",
    code: 672,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(672)?0?(3[58]){1,2}([A-Z]?\\d){4}$",
  },
  {
    id: 366,
    country: "Northern Mariana Islands",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(670[2-7][238]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 367,
    country: "Northern Mariana Islands",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(670[2-9][3-8][0-9]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 368,
    country: "Northern Mariana Islands",
    code: 1,
    length: 11,
    pattern: "####-#----",
    regex: "^0?0?(1)?0?(6708)([A-Z]?\\d){1}(8)([A-Z]?\\d){4}$",
  },
  {
    id: 369,
    country: "Norway",
    code: 47,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(47)?0?([45][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 370,
    country: "Norway",
    code: 47,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(47)?0?(9)([A-Z]?\\d){7}$",
  },
  {
    id: 371,
    country: "Oman",
    code: 968,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(968)?0?([79][1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 372,
    country: "Oman",
    code: 968,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(968)?0?(90[1-9]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 373,
    country: "Pakistan",
    code: 92,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(92)?0?(3[014]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 374,
    country: "Pakistan",
    code: 92,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(92)?0?(3[2-6][0-7]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 375,
    country: "Palau",
    code: 680,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(680)?0?([68][2-9][0-4]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 376,
    country: "Palau",
    code: 680,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(680)?0?(77)([A-Z]?\\d){5}$",
  },
  {
    id: 377,
    country: "Palestine",
    code: 970,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(970)?0?(5[69]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 378,
    country: "Panama",
    code: 507,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(507)?0?(61)([A-Z]?\\d){6}$",
  },
  {
    id: 379,
    country: "Panama",
    code: 507,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(507)?0?(6)([A-Z]?\\d){7}$",
  },
  {
    id: 380,
    country: "Panama",
    code: 507,
    length: 11,
    pattern: "##-----",
    regex: "^0?0?(507)?0?(8[17]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 381,
    country: "Papua New Guinea",
    code: 675,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(675)?0?([78][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 382,
    country: "Papua New Guinea",
    code: 675,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(675)?0?(775)([A-Z]?\\d){5}$",
  },
  {
    id: 383,
    country: "Paraguay",
    code: 595,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(595)?0?(9[6-9][1-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 384,
    country: "Peru",
    code: 51,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(51)?0?(9)([A-Z]?\\d){8}$",
  },
  {
    id: 385,
    country: "Philippines",
    code: 63,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(63)?0?(9[0-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 386,
    country: "Philippines",
    code: 63,
    length: 12,
    pattern: "#---------",
    regex: "^0?0?(63)?0?(9)([A-Z]?\\d){9}$",
  },
  {
    id: 387,
    country: "Poland",
    code: 48,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(48)?0?([5-8][0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 388,
    country: "Portugal",
    code: 351,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(351)?0?([69][0-6][89][03]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 389,
    country: "Portugal",
    code: 351,
    length: 12,
    pattern: "######---",
    regex: "^0?0?(351)?0?(6[356]9230){1,6}([A-Z]?\\d){3}$",
  },
  {
    id: 390,
    country: "Portugal",
    code: 351,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(351)?0?(9[1-6]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 391,
    country: "Puerto Rico",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?([79][38][79][2-9]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 392,
    country: "Qatar",
    code: 974,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(974)?0?([3-7]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 393,
    country: "Reunion",
    code: 262,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(262)?0?([69][79][36][0-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 394,
    country: "Romania",
    code: 40,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(40)?0?(7[0-7]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 395,
    country: "Romania",
    code: 40,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(40)?0?(7[189][0-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 396,
    country: "Romania",
    code: 40,
    length: 11,
    pattern: "####-----",
    regex: "^0?0?(40)?0?(7120)([A-Z]?\\d){5}$",
  },
  {
    id: 397,
    country: "Russian Federation",
    code: 7,
    length: 11,
    pattern: "#---------",
    regex: "^0?0?(7)?([0-9]{1})?(9)([A-Z]?\\d){8,9}$",
  },
  {
    id: 398,
    country: "Rwanda",
    code: 250,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(250)?0?(7[238]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 399,
    country: "Saint Barthelemy",
    code: 590,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(590)?0?(691[23][0-9]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 400,
    country: "Saint Helena Ascension and Tristan da C",
    code: 290,
    length: 8,
    pattern: "#----",
    regex: "^0?0?(290)?0?([56]){1,1}([A-Z]?\\d){4}$",
  },
  {
    id: 401,
    country: "Saint Kitts and Nevis",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(869[57][56][0-8]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 402,
    country: "Saint Kitts and Nevis",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(86966)([A-Z]?\\d){5}$",
  },
  {
    id: 403,
    country: "Saint Lucia",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(758[457][1-8]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 404,
    country: "Saint Lucia",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(7585[28][04]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 405,
    country: "Saint Martin",
    code: 590,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(590)?0?(691[23][0-9]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 406,
    country: "Saint Pierre and Miquelon",
    code: 508,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(508)?0?([45][0-5]){1,2}([A-Z]?\\d){4}$",
  },
  {
    id: 407,
    country: "Saint Vincent and the Grenadines",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(784[45][2-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 408,
    country: "Saint Vincent and the Grenadines",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(784489)([A-Z]?\\d){4}$",
  },
  {
    id: 409,
    country: "Samoa",
    code: 685,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(685)?0?([78][2-7]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 410,
    country: "Samoa",
    code: 685,
    length: 10,
    pattern: "##--------",
    regex: "^0?0?(685)?0?(89)([A-Z]?\\d){8}$",
  },
  {
    id: 411,
    country: "San Marino",
    code: 378,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(378)?0?(6[16]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 412,
    country: "Sao Tome and Principe",
    code: 239,
    length: 10,
    pattern: "####---",
    regex: "^0?0?(239)?0?(900[5-9]){1,4}([A-Z]?\\d){3}$",
  },
  {
    id: 413,
    country: "Sao Tome and Principe",
    code: 239,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(239)?0?(90[1-9]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 414,
    country: "Sao Tome and Principe",
    code: 239,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(239)?0?(9[89]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 415,
    country: "Saudi Arabia",
    code: 966,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(966)?0?(5[0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 416,
    country: "Saudi Arabia",
    code: 966,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(966)?0?(57[0-8]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 417,
    country: "Senegal",
    code: 221,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(221)?0?(7[0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 418,
    country: "Senegal",
    code: 221,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(221)?0?(7[29][01]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 419,
    country: "Serbia",
    code: 381,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(381)?0?(6[0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 420,
    country: "Serbia",
    code: 381,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(381)?0?(67)([A-Z]?\\d){7}$",
  },
  {
    id: 421,
    country: "Seychelles",
    code: 248,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(248)?0?(2[5-8]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 422,
    country: "Sierra Leone",
    code: 232,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(232)?0?([3-9][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 423,
    country: "Singapore",
    code: 65,
    length: 10,
    pattern: "###-----",
    regex: "^0?0?(65)?0?(89[23]){1,3}([A-Z]?\\d){5}$",
  },
  {
    id: 424,
    country: "Singapore",
    code: 65,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(65)?0?([6-8]{1})([A-Z]?\\d){7}$",
  },
  {
    id: 425,
    country: "Singapore",
    code: 65,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(65)?0?(9)([A-Z]?\\d){7}$",
  },
  {
    id: 426,
    country: "Sint Maarten",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(7215[158][0-9]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 427,
    country: "Sint Maarten",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(72152)([A-Z]?\\d){5}$",
  },
  {
    id: 428,
    country: "Slovakia",
    code: 421,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(421)?0?(9[01][0-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 429,
    country: "Slovakia",
    code: 421,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(421)?0?(909[1-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 430,
    country: "Slovakia",
    code: 421,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(421)?0?(9[45]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 431,
    country: "Slovenia",
    code: 386,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(386)?0?([46]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 432,
    country: "Slovenia",
    code: 386,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(386)?0?(51)([A-Z]?\\d){6}$",
  },
  {
    id: 433,
    country: "Slovenia",
    code: 386,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(386)?0?(651)([A-Z]?\\d){5}$",
  },
  {
    id: 434,
    country: "Slovenia",
    code: 386,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(386)?0?(6555)([A-Z]?\\d){4}$",
  },
  {
    id: 435,
    country: "Slovenia",
    code: 386,
    length: 11,
    pattern: "##-#----",
    regex: "^0?0?(386)?0?(65)([A-Z]?\\d){1}(0)([A-Z]?\\d){4}$",
  },
  {
    id: 436,
    country: "Slovenia",
    code: 386,
    length: 11,
    pattern: "--------",
    regex: "^0?0?(386)?0?([A-Z]?\\d){8}$",
  },
  {
    id: 437,
    country: "Solomon Islands",
    code: 677,
    length: 8,
    pattern: "##---",
    regex: "^0?0?(677)?0?(48)([A-Z]?\\d){3}$",
  },
  {
    id: 438,
    country: "Solomon Islands",
    code: 677,
    length: 8,
    pattern: "#------",
    regex: "^0?0?(677)?0?([789]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 439,
    country: "Solomon Islands",
    code: 677,
    length: 8,
    pattern: "##-----",
    regex: "^0?0?(677)?0?(9[1-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 440,
    country: "Somalia",
    code: 252,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(252)?0?(28)([A-Z]?\\d){5}$",
  },
  {
    id: 441,
    country: "Somalia",
    code: 252,
    length: 10,
    pattern: "#--------",
    regex: "^0?0?(252)?0?([348]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 442,
    country: "Somalia",
    code: 252,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(252)?0?([67][09]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 443,
    country: "Somalia",
    code: 252,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(252)?0?([679]){1,1}([A-Z]?\\d){7}$",
  },
  {
    id: 444,
    country: "Somalia",
    code: 252,
    length: 10,
    pattern: "##-------",
    regex: "^0?0?(252)?0?(90)([A-Z]?\\d){7}$",
  },
  {
    id: 445,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "####-----",
    regex: "^0?0?(27)?0?([18][07][024][89]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 446,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "#####----",
    regex: "^0?0?(27)?0?([18][257][134][159][0-8]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 447,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "######---",
    regex: "^0?0?(27)?0?([1-5][4-8]49[25]0){1,6}([A-Z]?\\d){3}$",
  },
  {
    id: 448,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(27)?0?(19)([A-Z]?\\d){7}$",
  },
  {
    id: 449,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "#-####---",
    regex: "^0?0?(27)?0?([1-5]){1,1}([A-Z]?\\d){1}(49[25]0){1,4}([A-Z]?\\d){3}$",
  },
  {
    id: 450,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "#-###----",
    regex: "^0?0?(27)?0?(4)([A-Z]?\\d){1}(492)([A-Z]?\\d){4}$",
  },
  {
    id: 451,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(27)?0?([67]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 452,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "#----",
    regex: "^0?0?(27)?0?(8)([A-Z]?\\d){4,8}$",
  },
  {
    id: 453,
    country: "South Africa",
    code: 27,
    length: 11,
    pattern: "-####----",
    regex: "^0?0?(27)?0?([A-Z]?\\d){1}(1492)([A-Z]?\\d){4}$",
  },
  {
    id: 454,
    country: "South Sudan",
    code: 211,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(211)?0?(9[1-7]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 455,
    country: "Spain",
    code: 34,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(34)?0?([67]{1})([A-Z]?\\d){8}$",
  },
  {
    id: 456,
    country: "Spain",
    code: 34,
    length: 11,
    pattern: "#######--",
    regex: "^0?0?(34)?0?(9)([A-Z]?\\d){7,8}$",
  },
  {
    id: 457,
    country: "Spain",
    code: 34,
    length: 11,
    pattern: "#####----",
    regex: "^0?0?(34)?0?(97390)([A-Z]?\\d){4}$",
  },
  {
    id: 458,
    country: "Sri Lanka",
    code: 94,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(94)?0?(7[0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 459,
    country: "Sudan",
    code: 249,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(249)?0?([19][0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 460,
    country: "Suriname",
    code: 597,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(597)?0?([78][1-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 461,
    country: "Svalbard and Jan Mayen",
    code: 47,
    length: 10,
    pattern: "##------",
    regex: "^0?0?(47)?0?([45][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 462,
    country: "Svalbard and Jan Mayen",
    code: 47,
    length: 10,
    pattern: "#-------",
    regex: "^0?0?(47)?0?(9)([A-Z]?\\d){7}$",
  },
  {
    id: 463,
    country: "Swaziland",
    code: 268,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(268)?0?(7[6-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 464,
    country: "Sweden",
    code: 46,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(46)?0?(7[0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 465,
    country: "Switzerland",
    code: 41,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(41)?0?([78][1-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 466,
    country: "Syrian Arab Republic",
    code: 963,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(963)?0?(9[3-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 467,
    country: "Syrian Arab Republic",
    code: 963,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(963)?0?(96[0-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 468,
    country: "Taiwan",
    code: 886,
    length: 12,
    pattern: "######---",
    regex: "^0?0?(886)?0?(40001[012]){1,6}([A-Z]?\\d){3}$",
  },
  {
    id: 469,
    country: "Taiwan",
    code: 886,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(886)?0?(9[0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 470,
    country: "Tajikistan",
    code: 992,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(992)?0?(41[18]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 471,
    country: "Tajikistan",
    code: 992,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(992)?0?([578][0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 472,
    country: "Tajikistan",
    code: 992,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(992)?0?(9)([A-Z]?\\d){8}$",
  },
  {
    id: 473,
    country: "Tanzania",
    code: 255,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(255)?0?([67][1-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 474,
    country: "Thailand",
    code: 66,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(66)?0?(6[1-6]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 475,
    country: "Thailand",
    code: 66,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(66)?0?([89]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 476,
    country: "Timor-Leste",
    code: 670,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(670)?0?(7[3-8]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 477,
    country: "Togo",
    code: 228,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(228)?0?([79][0-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 478,
    country: "Tokelau",
    code: 690,
    length: 7,
    pattern: "##--",
    regex: "^0?0?(690)?0?(7[234]){1,2}([A-Z]?\\d){2}$",
  },
  {
    id: 479,
    country: "Tonga",
    code: 676,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(676)?0?(63)([A-Z]?\\d){5}$",
  },
  {
    id: 480,
    country: "Tonga",
    code: 676,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(676)?0?(6[89][05]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 481,
    country: "Tonga",
    code: 676,
    length: 10,
    pattern: "#-#----",
    regex: "^0?0?(676)?0?(7)([A-Z]?\\d){1}(0)([A-Z]?\\d){4}$",
  },
  {
    id: 482,
    country: "Tonga",
    code: 676,
    length: 10,
    pattern: "#------",
    regex: "^0?0?(676)?0?([78]){1,1}([A-Z]?\\d){6}$",
  },
  {
    id: 483,
    country: "Trinidad and Tobago",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(868[26][68]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 484,
    country: "Trinidad and Tobago",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(868[24]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 485,
    country: "Trinidad and Tobago",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(8686[27][08]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 486,
    country: "Trinidad and Tobago",
    code: 1,
    length: 11,
    pattern: "###-#-----",
    regex: "^0?0?(1)?0?(868)([A-Z]?\\d){1}([01]){1,1}([A-Z]?\\d){5}$",
  },
  {
    id: 487,
    country: "Trinidad and Tobago",
    code: 1,
    length: 11,
    pattern: "###-------",
    regex: "^0?0?(1)?0?(868)([A-Z]?\\d){7}$",
  },
  {
    id: 488,
    country: "Tunisia",
    code: 216,
    length: 11,
    pattern: "####----",
    regex: "^0?0?(216)?0?(3001)([A-Z]?\\d){4}$",
  },
  {
    id: 489,
    country: "Tunisia",
    code: 216,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(216)?0?(3[16]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 490,
    country: "Tunisia",
    code: 216,
    length: 11,
    pattern: "###-----",
    regex: "^0?0?(216)?0?(391)([A-Z]?\\d){5}$",
  },
  {
    id: 491,
    country: "Tunisia",
    code: 216,
    length: 11,
    pattern: "#-##----",
    regex: "^0?0?(216)?0?(3)([A-Z]?\\d){1}(40)([A-Z]?\\d){4}$",
  },
  {
    id: 492,
    country: "Tunisia",
    code: 216,
    length: 11,
    pattern: "#-------",
    regex: "^0?0?(216)?0?(4)([A-Z]?\\d){7}$",
  },
  {
    id: 493,
    country: "Tunisia",
    code: 216,
    length: 11,
    pattern: "--------",
    regex: "^0?0?(216)?0?([A-Z]?\\d){8}$",
  },
  {
    id: 494,
    country: "Turkey",
    code: 90,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(90)?0?(5[0-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 495,
    country: "Turkey",
    code: 90,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(90)?0?(524)([A-Z]?\\d){7}$",
  },
  {
    id: 496,
    country: "Turkey",
    code: 90,
    length: 12,
    pattern: "#####-----",
    regex: "^0?0?(90)?0?(56161)([A-Z]?\\d){5}$",
  },
  {
    id: 497,
    country: "Turkey",
    code: 90,
    length: 12,
    pattern: "#---------",
    regex: "^0?0?(90)?0?(5)([A-Z]?\\d){9}$",
  },
  {
    id: 498,
    country: "Turkmenistan",
    code: 993,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(993)?0?(6[1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 499,
    country: "Turks and Caicos Islands",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(649[23][34]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 500,
    country: "Turks and Caicos Islands",
    code: 1,
    length: 11,
    pattern: "####------",
    regex: "^0?0?(1)?0?(6494)([A-Z]?\\d){6}$",
  },
  {
    id: 501,
    country: "Tuvalu",
    code: 688,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(688)?0?(7[01]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 502,
    country: "Tuvalu",
    code: 688,
    length: 10,
    pattern: "##----",
    regex: "^0?0?(688)?0?(90)([A-Z]?\\d){4}$",
  },
  {
    id: 503,
    country: "Uganda",
    code: 256,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(256)?0?(7[0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 504,
    country: "Uganda",
    code: 256,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(256)?0?(7[24][0-4]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 505,
    country: "Uganda",
    code: 256,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(256)?0?(7260)([A-Z]?\\d){5}$",
  },
  {
    id: 506,
    country: "Ukraine",
    code: 380,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(380)?0?([5-9][0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 507,
    country: "United Arab Emirates",
    code: 971,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(971)?0?(5[0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 508,
    country: "United Kingdom",
    code: 44,
    length: 12,
    pattern: "####------",
    regex: "^0?0?(44)?0?(7[479][015][017]){1,4}([A-Z]?\\d){6}$",
  },
  {
    id: 509,
    country: "United Kingdom",
    code: 44,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(44)?0?(7[4-9][0-9]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 510,
    country: "United Kingdom",
    code: 44,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(44)?0?(7[3-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 511,
    country: "United States",
    code: 1,
    length: 11,
    pattern: "##--------",
    regex: "^0?0?(1)?0?([2-9][0-8]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 512,
    country: "United States",
    code: 1,
    length: 11,
    pattern: "###-------",
    regex: "^0?0?(1)?0?([456][257][08]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 513,
    country: "United States",
    code: 1,
    length: 11,
    pattern: "#---------",
    regex: "^0?0?(1)?0?(6)([A-Z]?\\d){9}$",
  },
  {
    id: 514,
    country: "Uruguay",
    code: 598,
    length: 11,
    pattern: "##------",
    regex: "^0?0?(598)?0?(9[1-9]){1,2}([A-Z]?\\d){6}$",
  },
  {
    id: 515,
    country: "Uzbekistan",
    code: 998,
    length: 12,
    pattern: "####-----",
    regex: "^0?0?(998)?0?([67][1-9][1-9][0-9]){1,4}([A-Z]?\\d){5}$",
  },
  {
    id: 516,
    country: "Uzbekistan",
    code: 998,
    length: 12,
    pattern: "#####----",
    regex: "^0?0?(998)?0?([67][1-9][2-7][2-9][0-9]){1,5}([A-Z]?\\d){4}$",
  },
  {
    id: 517,
    country: "Uzbekistan",
    code: 998,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(998)?0?([67][1-9][3-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 518,
    country: "Uzbekistan",
    code: 998,
    length: 12,
    pattern: "###-#----",
    regex: "^0?0?(998)?0?([67][25][27]){1,3}([A-Z]?\\d){1}([147]){1,1}([A-Z]?\\d){4}$",
  },
  {
    id: 519,
    country: "Uzbekistan",
    code: 998,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(998)?0?(9)([A-Z]?\\d){8}$",
  },
  {
    id: 520,
    country: "Vanuatu",
    code: 678,
    length: 10,
    pattern: "##-----",
    regex: "^0?0?(678)?0?([57][0-9]){1,2}([A-Z]?\\d){5}$",
  },
  {
    id: 521,
    country: "Vanuatu",
    code: 678,
    length: 10,
    pattern: "###----",
    regex: "^0?0?(678)?0?(57[2-5]){1,3}([A-Z]?\\d){4}$",
  },
  {
    id: 522,
    country: "Vatican City State",
    code: 39,
    length: 12,
    pattern: "##--------",
    regex: "^0?0?(39)?0?(3[1-9]){1,2}([A-Z]?\\d){8}$",
  },
  {
    id: 523,
    country: "Vatican City State",
    code: 39,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(39)?0?(3[2-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 524,
    country: "Venezuela",
    code: 58,
    length: 12,
    pattern: "###-------",
    regex: "^0?0?(58)?0?(4[12][2-8]){1,3}([A-Z]?\\d){7}$",
  },
  {
    id: 525,
    country: "Vietnam",
    code: 84,
    length: 11,
    pattern: "#--------",
    regex: "^0?0?(84)?0?([3-9]){1,1}([A-Z]?\\d){8}$",
  },
  {
    id: 526,
    country: "Vietnam",
    code: 84,
    length: 11,
    pattern: "###------",
    regex: "^0?0?(84)?0?(879)([A-Z]?\\d){6}$",
  },
  {
    id: 527,
    country: "Vietnam",
    code: 84,
    length: 11,
    pattern: "##-------",
    regex: "^0?0?(84)?0?([89]9){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 528,
    country: "Virgin Islands British",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(284[345][049]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 529,
    country: "Virgin Islands British",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(284[34][69][689]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 530,
    country: "Virgin Islands US",
    code: 1,
    length: 11,
    pattern: "#####-----",
    regex: "^0?0?(1)?0?(340[2-7][0-9]){1,5}([A-Z]?\\d){5}$",
  },
  {
    id: 531,
    country: "Virgin Islands US",
    code: 1,
    length: 11,
    pattern: "######----",
    regex: "^0?0?(1)?0?(340[2-9][2-9][2-9]){1,6}([A-Z]?\\d){4}$",
  },
  {
    id: 532,
    country: "Wallis and Futuna",
    code: 681,
    length: 9,
    pattern: "##----",
    regex: "^0?0?(681)?0?(8[23]){1,2}([A-Z]?\\d){4}$",
  },
  {
    id: 533,
    country: "Western Sahara",
    code: 212,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(212)?0?([67][0-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 534,
    country: "Western Sahara",
    code: 212,
    length: 12,
    pattern: "#--------",
    regex: "^0?0?(212)?0?(6)([A-Z]?\\d){8}$",
  },
  {
    id: 535,
    country: "Yemen",
    code: 967,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(967)?0?(7[0-7]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 536,
    country: "Zaire",
    code: 243,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(243)?0?([89][0-9]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 537,
    country: "Zaire",
    code: 243,
    length: 12,
    pattern: "##-----",
    regex: "^0?0?(243)?0?(88)([A-Z]?\\d){5}$",
  },
  {
    id: 538,
    country: "Zambia",
    code: 260,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(260)?0?([79][5-8]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 539,
    country: "Zimbabwe",
    code: 263,
    length: 12,
    pattern: "##-------",
    regex: "^0?0?(263)?0?(7[17]){1,2}([A-Z]?\\d){7}$",
  },
  {
    id: 540,
    country: "Zimbabwe",
    code: 263,
    length: 12,
    pattern: "###------",
    regex: "^0?0?(263)?0?(7[38][1-9]){1,3}([A-Z]?\\d){6}$",
  },
  {
    id: 542,
    country: "Germany",
    code: 49,
    length: 13,
    pattern: "###--------",
    regex: "^0?0?(49)?0?([12][5-7][0-9]){1,3}([A-Z]?\\d){7,9}$",
  },
  {
    id: 543,
    country: "Default",
    code: 0,
    length: 0,
    pattern: "--",
    regex:
      "^0?0?([17])?0?([A-Z]?\\d){10,11}$|^0?0?(20|27|30|31|32|33|34|36|39|40|41|43|44|45|46|47|48|49|51|52|53|54|55|56|57|58|60|61|62|63|64|65|66|81|82|84|86|90|91|92|93|94|95|98)?0?(11)?([A-Z]?\\d){7,11}$|^0?0?(211|212|213|216|218|220|221|222|223|224|225|226|227|228|229|230|231|232|233|234|235|236|237|238|239|240|241|242|243|244|245|246|248|249|250|251|252|253|254|255|256|257|258|260|261|262|263|264|265|266|267|268|269|290|291|297|298|299|350|351|352|353|354|355|356|357|358|359|370|371|372|373|374|375|376|377|378|380|381|382|385|386|387|389|420|421|423|500|501|502|503|504|505|506|507|508|509|590|591|592|593|594|595|596|597|598|599|670|672|673|674|675|676|677|678|679|680|681|682|683|685|686|687|688|689|690|691|692|850|852|853|855|856|880|886|960|961|962|963|964|965|966|967|968|970|971|972|973|974|975|976|977|992|993|994|995|996|998)?0?(11)?([A-Z]?\\d){6,9}$",
  },
];
